import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderSearchService {
  private readonly searchTermSubject = new BehaviorSubject<string>('');
  private readonly createCommandSubject = new BehaviorSubject<string | null>(null);
  readonly searchTerm$ = this.searchTermSubject.asObservable();
  readonly createCommand$ = this.createCommandSubject.asObservable();

  setSearchTerm(term: string) {
    this.searchTermSubject.next((term || '').trim());
  }

  getSearchTerm(): string {
    return this.searchTermSubject.value;
  }

  requestCreateCommand(commandKey: string) {
    this.createCommandSubject.next(commandKey || null);
  }

  clearCreateCommand(commandKey?: string) {
    if (!commandKey || this.createCommandSubject.value === commandKey) {
      this.createCommandSubject.next(null);
    }
  }
}
